<template>
    

        <div class="news-content">
            
            <div class="tabs d_f P_sl jc_c">
                <div class="tab" :key="0" :class="active == 0 ? 'active':''" @click="tabChange(0,true)" >
                    全部
                </div>
                <div class="tab" 
                    v-for="(item) in tabs" 
                    :key="item.type" 
                    @click="tabChange(item.type,true)" 
                    :class="active == item.type ? 'active':''">
                    {{item.name}}
                </div>
            </div>

            <div class="d_f jc_sb cont">
                <div v-if="loading">
                    <div v-for="item in 5" :key="item" style="margin-bottom: 20px;">
                        <a-skeleton active :avatar="{shape:'square',size:300}" :title='{width:670,height:100}' :paragraph='{rows:8,width:[670,670,670,670,670,670,670,670]}'/>
                    </div>
                </div>
                <div class="d_f_1" v-else>
                    <div class="news-list" v-if="newsList && newsList.length > 0">
                        <newsItem 
                            v-for="(item) in newsList" 
                            :key="item.id" 
                            :title="item.title"
                            :img='item.newsPicUrl'
                            :desc='item.contents'
                            :date = 'item.createTime'
                            :to='"/news/details?id="+item.id'
                        />
                        <Pagetion @pageActive='pageActive' :defaultPage='page' v-if="newsList.length > 0" :pageSize="pagelength"/>
                    </div>
                    <div class="d_f_1 jc_c" v-else>
                        <a-result status="500" title="暂时没有数据" sub-title="No data at present" />
                    </div>
                </div>
                <div class="news-cate">
                    <p>时间筛选</p>
                    <ul>
                        <li 
                            v-for="(item,index) in cate" 
                            :key="item.id" 
                            @click='tabTime(item.id,index)'
                            :class="item.id == cate_active ? 'active' : ''"
                            >
                            {{item.name}}
                        </li>
                    </ul>
                </div>
            </div>
            
            <!--                 
                :on-refresh="refresh"
                :on-infinite="infinite" 
            -->
            <div class="scroll">
                <div v-if="loading">
                    <div v-for="item in 5" :key="item" style="margin-bottom: 20px;">
                        <a-skeleton active :avatar="{shape:'square',size:100}" :title='{width:150,}' :paragraph='{rows:2}'/>
                    </div>
                </div>
                    <scroller 
                        class="news-scroll"
                        :on-infinite="infinite" 
                        ref="myscroller"
                        v-else
                    >
                            <newsItem 
                            v-for="(item) in newsList" 
                            :key="item.id" 
                            :title="item.title"
                            :img='item.newsPicUrl'
                            :desc='item.contents'
                            :date = 'item.createTime'
                            :to='"/news/details?id="+item.id'
                        />
                    </scroller>
            </div>
        </div>



</template>


<script>
import index from './index'
import newsItem from './news-item'
import Pagetion from '../../components/Pagetion/index.vue'
// import NoData from '../../components/no-data/index'
export default {
    ...index,
    components : {
        newsItem,
        Pagetion,
    }
}
</script>

<style lang="scss" scoped>
    .news-content{
        width: 1200px;
        margin: 80px auto;
        .tabs{
            margin-bottom: 65px;
            .tab{
                position: relative;
                line-height: 60px;
                margin: 0 30px;
                cursor: pointer;
            }
            .active::after{
                content:'';
                position: absolute;
                width: 78px;
                height: 7px;
                background-color: #0067cc;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
            }
        }
        .news-list{
            width: 970px;
        }
        .news-cate{
            width: 113px;
            margin-top: 40px;
            li{
                line-height: 50px;
                border-bottom: 3px solid transparent;
                cursor: pointer;
            }
            .active{
                border-bottom: 3px solid #0067cc;
            }
        }

        .scroll{
            display: none;
        }
    }


    @media screen and (max-width: 750px){
        .news-content{
            // position: relative;
            width: 100%;
            margin: 0 auto;
            padding: 0 2.66vw;
            background-color: #F8F8F8;
            height: calc(100vh - 13.298vw);
            overflow: hidden;
        }
        .cont{
            display: none;
        }
        .news-cate,.news-list{
            display: none;
        }
        .tabs{
            margin: 0 !important ;
            padding: 5.319vw 0;
            justify-content: space-around !important;
            .tab{
                width: 20.213vw;
                line-height: 7.447vw !important;
                font-size: 3.458vw;
                margin: 0 !important;
                text-align: center;
                border:1px solid #ccc;
                border-radius: 1.33vw;

            }
            .active::after{
                content:'';
                display: none;
            }
            .active{
                border:1px solid #0067cc;
                background-color: #e5eff9;
                color: #0067cc;
            }
        }
        .scroll{
            display: block !important;
            position: relative;
            width: 100%;
            height: calc(100vh - 60.957vw) !important; 
            .fill{
                width: 100%;
                height: 26.596vw;
            }
        }
        .news-scroll{
            display: block !important;
            // top: 30.957vw !important;
            // position: relative !important;
            // height: calc(100vh - 30.957vw) !important; 
            height: 100%;
            padding: 0 2.66vw;
        }

    }

</style>